<ng-container>
  <div class="content">
  <h3>{{'Do you want delete this annotation'}}</h3>
  <div class="button-container">
    <button mat-stroked-button
            (click)="dialogRef.close(true)"
            color="primary" class="save-btn">
      Delete
    </button>
    <button mat-stroked-button
            (click)="dialogRef.close()"
            class="cancel-btn">
      Cancel
    </button>
  </div>
  </div>
</ng-container>
